import classNames from 'classnames';
import React, { Children, useEffect } from 'react';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import Icon, { Icons } from '../Icon/Icon';

import './PeriodFilter.scss';
import { useNavigate } from 'react-router';
import AppConfig from '../../config';

const { routes } = AppConfig;

const PeriodFilter = ({
	period: _period = null,
	onChange = () => {},
	children,
}) => {
	const period = sessionStorage.getItem('filter-period');

	const navigate = useNavigate();

	useEffect(() => {
		if (period && !_period) {
			onChange(period);
		}
	}, [period, _period]);

	const openFilterPage = () => {
		navigate({ pathname: routes.periodFilterPage }, { state: { period } });
	};

	useEffect(() => {
		return sessionStorage.removeItem('filter-period');
	}, []);

	return <div onClick={openFilterPage}>{children}</div>;
};

export default PeriodFilter;
